import { render, staticRenderFns } from "./ui-notification.vue?vue&type=template&id=841fab1c&scoped=true&"
import script from "./ui-notification.vue?vue&type=script&lang=js&"
export * from "./ui-notification.vue?vue&type=script&lang=js&"
import style0 from "./ui-notification.vue?vue&type=style&index=0&id=841fab1c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "841fab1c",
  null
  
)

export default component.exports